(function () {
    'use strict';

    a3_cabin_reports.directive('competencesReadOnly', competencesReadOnly);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name competencesReadOnly
    * @restrict E
    * @description
    *    Implementation of competences read only
    * @example
    *   Usage:
    *   <competences-read-only></competences-read-only>
    * @ngInject
    */
    function competencesReadOnly() {
        function link(scope, element, attrs) {
            if(scope.trainee.Competences){
                scope.trainee.Competences.forEach(function (competence) {
                    competence.hasSelectedSubCompetence = competence.SubCompetences.some(x => x.Selected);
                });        
            }
               
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/TrainingReadOnly/competences-read-only.tpl.html',
            scope: {trainee : "="},
            link: link
        }
    }

})();
